import { Component, Inject, Input, OnInit, Optional } from "@angular/core";
import { IPopupScreenData } from "src/app/common/models/popup-screen-data.model";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DepositsInfo } from "../models/deposits-info.model";
import { DepositDetailService } from "./deposit-detail-form.service";

import { Router } from "@angular/router";
import { BaseFpxFormComponent, ValidatorService } from "@fpx/core";
import { DepositService } from "../services/deposits.service";
import { PopupComponent } from "src/app/common/components/popup/popup.component";
import {
  DepositDetailHelper,
  DepositDetailState,
} from "./deposit-detail-form.helper";
import { ControlContainer, FormBuilder } from "@angular/forms";
import { AccountsService } from "src/app/services/accounts/accounts.service";
import { CustomerService } from "src/app/services/customer.service";
import { CommonService } from "src/app/common.service";
import { ResponsiveService } from "src/app/responsive.service";

@Component({
  selector: "app-deposit-detail-form",
  templateUrl: "./deposit-detail-form.component.html",
  styleUrls: ["./deposit-detail-form.component.scss"],
})
export class DepositDetailComponent extends BaseFpxFormComponent<
  DepositDetailHelper,
  DepositDetailState
> {
  depositDetail;
  popupData: any;
  @Input() transactionInfo: DepositsInfo;
  constructor(
    @Optional() controlContainer: ControlContainer,
    @Inject(MAT_DIALOG_DATA) protected data: IPopupScreenData,
    private _depositdetail: DepositService,
    private router: Router,
    formBuilder: FormBuilder,
    public popupcomponent: PopupComponent,
    protected ddHelper: DepositDetailHelper,
    private ddservice: DepositDetailService,
    private _accountService:AccountsService,
    private _depositService: DepositService,
    private _customerService:CustomerService,
    protected commonService:CommonService,
    protected _responsive:ResponsiveService
  ) {
    super(formBuilder, router, controlContainer, ddHelper);
  }


  redeem() {
    this.popupcomponent.closePopup();
    let path = this.commonService.isDesktop()?["home", "transactions","process-shell", "deposits", "redeem-deposit-request-form"]:["process-shell", "deposits", "redeem-deposit-request-form"]


    this._depositdetail.getDepositsList();
    this.router.navigate(
      path,
      {
        queryParams: {
          referenceKey: this.popupData.accountNumber,
          processCode: "REDEEMDEPOSIT",
          processTitle: "Reedem Deposit",
          category: "deposit",
          accType: "deposits",
          desktopPath:["home", "transactions","process-shell", "deposits", "redeem-deposit-request-form"],
          additionalDetails: {
            backNav: ["home", "transactions"],
            queryParams: {
              "touchedData":{
                category: "deposit",

                "ngTemplateName": "depositSummaryCardTmplt"
              }

            }

          },
        },
        queryParamsHandling: "preserve",
      }
    );
  }

  protected doPreInit(): void {

    this.popupData = this.data?.screenData?.data;
    let accountNum = this.popupData.accountNumber;
          this.ddservice.fetchDepositInfo(accountNum).subscribe((item)=>
   this.depositDetail=item
    )
    let nickName = this._customerService.getNickname(accountNum);
    this.state.nickname = nickName;

  }

  edit() {
    this.popupcomponent.closePopup();
    let nickName = this._customerService.getNickname(this.popupData.accountNumber);
    let path = this.commonService.isDesktop()?["home", "transactions","process-shell", "casa-accounts", "account-nickname"]:["process-shell", "casa-accounts", "account-nickname"]

    this.router.navigate(path,
     {
      queryParams: {
        referenceKey:this.popupData.accountNumber,
        processCode: "ACCNICKNAME",
        processTitle: "Nickname",
        category: "deposit",
        path:["process-shell", "casa-accounts", "account-nickname"],
        desktopPath:["home", "transactions","process-shell", "casa-accounts", "account-nickname"],
        accType: "deposits",
        action: nickName ? "MODIFY" : "ADD",
        additionalDetails: {
          backNav: ["home", "transactions"],
          queryParams: {
            "touchedData":{
              category: "deposit",
              "ngTemplateName": "depositSummaryCardTmplt"
            }

          }
        },
      },
      queryParamsHandling: "preserve",
    });
  }
}
